import { render, staticRenderFns } from "./SearchFilterTokens-v2.vue?vue&type=template&id=58b0c7ea&scoped=true&"
import script from "./SearchFilterTokens-v2.vue?vue&type=script&lang=js&"
export * from "./SearchFilterTokens-v2.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58b0c7ea",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('58b0c7ea')) {
      api.createRecord('58b0c7ea', component.options)
    } else {
      api.reload('58b0c7ea', component.options)
    }
    module.hot.accept("./SearchFilterTokens-v2.vue?vue&type=template&id=58b0c7ea&scoped=true&", function () {
      api.rerender('58b0c7ea', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2m5Ir3XrvhaBM/JS/comp/SearchFilterTokens-v2.vue"
export default component.exports